<template>
  <!-- 通勤 -->
  <div>
    <CCard>
      <CCardHeader>
        <h2>通勤費精算(仮払申請)</h2>
      </CCardHeader>
      <CCardBody>
        <table class="table search-table">
          <tr>
            <th style="width: 100px">年月</th>
            <th style="width: 75px"></th>
            <th style="width: 50px"></th>
            <th></th>
          </tr>
          <tr>
            <td>
              <select
                class="custom-select"
                v-model="year"
                style="width: 90px"
              >
                <option
                  v-for="option in yearOption"
                  :value="option.id"
                  :key="option.id"
                >
                  {{ option.name }}
                </option>
              </select>
            </td>
            <td>
              <select
                class="custom-select"
                v-model="month"
                style="width: 70px"
              >
                <option
                  v-for="option in monthOption"
                  :value="option.id"
                  :key="option.id"
                >
                  {{ option.name }}
                </option>
              </select>
            </td>
            <td>業務分</td>
            <td>
              <button class="btn btn-primary" @click="callList">表示</button>
            </td>
          </tr>
        </table>
        <br />※普段の通勤以外の交通費は「経費精算」にて申請して下さい。
      </CCardBody>
      <template v-if="displayFlg">
        <CCardHeader>
          <tr><td>
            <strong
              v-if="showYearMonth"
              style="font-size: 20px; font-weight: bold"
            >
              {{ selectYear }} 年 {{ selectMonth }} 月
              <span style="margin-left: 10px"></span>
              <span :style="statusColor(status)">【{{ getStatusLabel(status) }}】</span>
            </strong>
          </td></tr>
          <tr><td v-if="errors.length">
            <div style="color: red" v-for="error in errors" :key="error">
              {{ error }}
            </div>
          </td></tr>
        </CCardHeader>
        <CCardHeader>
          <strong>通勤費</strong>
        </CCardHeader>
        <CCardBody>
          <ExpenseError
            ref="error"
            :day1="day1"
            :origin="origin"
            :destination="destination"
            :route="route"
            :cost="cost"
            :temporary="temporary"
            :remarks="remarks"
          ></ExpenseError>
          <CRow>
            <CCol>
              <tr><td><span class="asterisk">*</span>が付いている項目は必須入力項目です
              </td></tr>
            </CCol>
          </CRow>
          <CRow>
            <div class="table-responsive">
              <table class="table table-bordered">
                <thead>
                  <tr>
                    <th width="100px" nowrap>
                      <div>年月日<span class="asterisk">*</span></div>
                      <div>プロジェクト名</div>
                    </th>
                    <th width="100px" nowrap>
                      <div>金額<span class="asterisk">*</span></div>
                      <div>仮払(事前受取額)</div>
                    </th>
                    <th width="100px" nowrap>
                      <div>交通機関<span class="asterisk">*</span></div>
                      <div>内訳(備考)</div>
                    </th>
                    <th width="100px" nowrap>
                      <div>出発<span class="asterisk">*</span></div>
                      <div>到着<span class="asterisk">*</span></div>
                    </th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(n, index) in lists1" :key="index">
                    <td>
                      {{ selectYear }}年{{ selectMonth }}月
                      <select
                        class="custom-select"
                        v-model="day1[index]"
                        @blur="day1_check"
                        style="width: 60px;margin-bottom: 7px;"
                      >
                        <option v-for="option in days" :key="option">
                          {{ option }}
                        </option>
                      </select>
                      日<br>
                      <select
                        class="custom-select"
                        v-model="project_id[index]"
                        @change="syncProjectName(index)"
                        style="width: 180px;margin-top: 15px;margin-bottom: 0px;"
                      >
                        <option v-for="p in projectList" :key="p.id" :value="p.id">
                          {{ p.name }}<template v-if="p.external">（現在所属外）</template>
                        </option>
                      </select>
                    </td>
                    <td>
                      <CInput
                        v-model="cost[index]"
                        @beforeinput.native="digitsOnly('cost', index, $event)"
                        @input.native="sanitizeDigits('cost', index)"
                        @focus="deleteCost"
                        @blur="addCost"
                        inputmode="numeric"
                        pattern="[0-9]*"
                        style="width: 100px; margin-bottom: 0px;"
                        placeholder="金額"
                      />
                      <br/>
                      <CInput
                        v-model="temporary[index]"
                        @beforeinput.native="digitsOnly('temporary', index, $event)"
                        @input.native="sanitizeDigits('temporary', index)"
                        @focus="deleteTemporary"
                        @blur="addTemporary"
                        inputmode="numeric"
                        pattern="[0-9]*"
                        style="width: 100px; margin-top: 0px; margin-bottom: 0px;"
                        placeholder="仮払金額"
                      />
                    </td>
                    <td>
                      <CInput
                        v-model="route[index]"
                        @blur="route_check"
                        style="width: 300px;margin-bottom: 0px;"
                        placeholder="交通機関"
                      />
                      <br/>
                      <CInput
                        v-model="remarks[index]"
                        @blur="remarks_check"
                        style="width: 300px;margin-bottom: 0px;"
                        placeholder="(例)地下鉄300円*12回、定期購入など"
                      />
                    </td>
                    <td>
                      <CInput
                        v-model="origin[index]"
                        @blur="origin_check"
                        style="width: 100px;margin-top: 10px;margin-bottom: 0px;"
                        placeholder="出発"
                      /><br/>
                      <CInput
                        v-model="destination[index]"
                        @blur="destination_check"
                        style="width: 100px;margin-bottom: 10px;"
                        placeholder="到着"
                      />
                    </td>
                    <td>
                      <button
                        class="btn btn-danger deleteBtn"
                        :disabled="statusBtn"
                        @click="deleteCheck1(index)"
                        style="margin-top: 17px;"
                      >
                        削除
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </CRow>
          <CRow>
            <CCol sm="1">
              <button
                @click="addForm1"
                class="btn btn-primary btn-add"
                :disabled="!activeAddButton || statusBtn"
              >
                追加
              </button>
            </CCol>
          </CRow>
        </CCardBody>
        <CCardHeader>
          <strong>合計支払額</strong>
        </CCardHeader>
        <CCardBody>
          <CRow>
            <table class="table">
              <thead>
                <tr>
                  <th class="title" >
                    <label>通勤費合計</label>
                  </th>
                  <th class="title" >
                    <label>仮払小計</label>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td class="frame-line">
                    <span>{{ totalCost }}</span>
                  </td>
                  <td class="frame-line">
                    <span>{{ totalTemporary }}</span>
                  </td>
                </tr>
              </tbody>
              <thead>
                <tr>
                  <th class="title" colspan="2">
                    <label>差引戻・払額</label>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td class="frame-line" colspan="2">
                    <span>{{ sumPayment }}</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </CRow>
          <CRow>
            <CCol class="text-center">
              <save-button
                :label="'保存'"
                :loading="loading"
                class="btn btn-primary btn-register"
                @click="edit"
                :disabled="activeButton || statusBtn"
              />
              <p class="text-center text-muted my-2">
              ※保存後、他申請書類とまとめて「承認申請一覧」にて承認申請を行ってください。
              </p>
            </CCol>
          </CRow>
        </CCardBody>
      </template>
    </CCard>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import ConstList from "./../../ConstList";
import SubmissionConst from "./../../submission_approval/ConstList";
import ExpenseError from "./ExpenseError";
import SaveButton from '../../common/SaveButton';
export default {
  name: "Commute",
  components: {
    ExpenseError,
    SaveButton,
  },
  data() {
    return {
      num1: 0,
      id: [],
      year: "",
      month: "",
      project: "",
      projectList: [],
      name: "",
      days: [],
      project_name: [],
      project_id: [],
      day1: [],
      request_type: [],
      user_id: [],
      origin: [],
      destination: [],
      route: [],
      cost: [],
      remarks: [],
      temporary: [],
      sum_transport: [],
      sum_expense: [],
      sum_stay: [],
      sum_commute: [],
      sum_cost: [],
      sum_temporary: [],
      total: [],
      status: "",
      errors: [],
      // 二重サブミット対処フラグ
      editSubmit: false,
      activeAddButton: false,
      showYearMonth: false,
      submit_flg: false,
      // 状態によるボタン非活性化
      statusBtn: false,
      displayFlg: false,
      loading: false,
    };
  },
  created() {
    this.yearOption = ConstList.YEAR_OPTION;
    this.monthOption = ConstList.MONTH_OPTION;
  },

  methods: {
    // DBから一覧呼出メソッド
    callList: function () {
      this.displayFlg = false;
      const params = new URLSearchParams();
      params.append("year", this.year);
      params.append("month", this.month);
      axios
        .get(process.env.VUE_APP_API_ORIGIN + "/commuteSelect", {
          params: {
            year: this.year,
            month: this.month,
          },
        })
        .then((response) => {
          this.num1 = 0;
          this.id = [];
          this.project_id = [];
          this.project_name = [];
          this.day1 = [];
          this.origin = [];
          this.user_id = [];
          this.destination = [];
          this.route = [];
          this.cost = [];
          this.remarks = [];
          this.days = [];
          this.temporary = [];
          (this.displayFlg = true), (this.status = "");
          this.errors = [];
          this.statusBtn = false;
          this.activeAddButton = true;
          this.showYearMonth = true;
          this.selectYear = this.year;
          this.selectMonth = this.month;
          const start = moment(this.year + "-" + this.month + "-01").startOf(
            "month"
          );
          const end = moment(this.year + "-0" + this.month + "-01").endOf(
            "month"
          );
          while (start.unix() <= end.unix()) {
            this.days.push(start.format("D"));
            start.add(1, "days");
          }
          response.data.forEach((element) => {
            try {
              this.num1++;
              this.id.push(element.id);
              this.project_id.push(element.project_id);
              this.project_name.push(element.project_name);
              this.day1.push(element.date.substring(8).replace(/^0+/, ""));
              this.origin.push(element.origin);
              this.destination.push(element.destination);
              this.route.push(element.route);
              this.cost.push(element.cost + "");
              this.remarks.push(element.remarks);
              this.temporary.push(element.temporary + "");
              this.status = element.status;
            } catch (error) {
              if (!element.project_name) {
                alert("プロジェクト管理にて、プロジェクトを設定して下さい。");
                this.$router.push({
                  name: ConstList.ROUTE_PROJECT_LIST,
                });
              }
            }
          });
          // 承認待ち状態はメッセージ表示とボタン非活性化
          if (this.status == ConstList.APPROVAL_PENDING) {
            this.errors.push(SubmissionConst.ERROR_UPDATE_MESSAGE_PENDING);
            this.statusBtn = true;
          }
          // 承認済み状態はメッセージ表示とボタン非活性化
          else if (this.status == ConstList.APPROVAL) {
            this.errors.push(SubmissionConst.ERROR_UPDATE_MESSAGE_APPROVAL);
            this.statusBtn = true;
          }
          return axios.get(process.env.VUE_APP_API_ORIGIN + '/projects');
          })
          .then(({ data: belong }) => {
            const belongArr  = (belong || []).map(p => ({ id:+p.id, name:p.name }));
            const belongIdSet = new Set(belongArr.map(p => p.id));
            const fromItems = (this.project_id || [])
              .map((id,i)=> (id!=null && !isNaN(+id)) ? { id:+id, name:this.project_name?.[i] || `(ID:${+id})` } : null)
              .filter(Boolean);
            const map = new Map();
            [...belongArr, ...fromItems].forEach(p => {
              if (!map.has(p.id)) map.set(p.id, { id:p.id, name:p.name, external: !belongIdSet.has(p.id) });
            });
            this.projectList = Array.from(map.values());
            // 未選択なら先頭を既定でセット
            if (this.projectList.length) {
              for (let i = 0; i < this.num1; i++) {
                if (!this.project_id[i]) {
                  this.$set(this.project_id, i, this.projectList[0].id);
                  this.$set(this.project_name, i, this.projectList[0].name);
                }
              }
            }
          })
        .catch((error) => {
          this.displayFlg = false;
          axios
          .get(
            `${process.env.VUE_APP_API_ORIGIN}/error/frontError/${error}`
          )
          .then(() => {
            alert(ConstList.SYSTEM_ERROR);
          })
          .catch(() => {
            alert(ConstList.SYSTEM_COMMUNICATION_ERROR);
          });
        });
    },

    // 金額3桁ごとにカンマを付けるメソッド
    addComma: function (value) {
      const list = value;
      for (let i = 0; i < list.length; i++) {
        const comma = list[i]
          .toString()
          .replace(/([0-9]+?)(?=(?:[0-9]{3})+$)/g, "$1,");
        list.splice(i, 1, comma);
        if (!comma) {
          list.splice(i, 1, "");
        }
      }
    },
    // カンマ付加と金額のエラーチェックメソッド(通勤費)
    addCost: function () {
      this.$refs.error.cost_empty();
      this.addComma((this.cost));
      this.$refs.error.cost_regex();
    },
    // カンマ付加メソッド(仮払)
    addTemporary: function () {
      this.addComma((this.temporary));
      this.$refs.error.temporary_regex();
    },
    // フォーカスが当たるとカンマを外すメソッド
    deleteComma: function (value) {
      const list = value;
      for (let i = 0; i < list.length; i++) {
        const comma = list[i].replace(/,/g, "");
        list.splice(i, 1, comma);
        if (!comma) {
          list.splice(i, 1, "");
        }
      }
    },
    // カンマ除去メソッド(通勤費)
    deleteCost: function () {
      this.deleteComma((this.cost));
    },
    // カンマ除去メソッド(仮払)
    deleteTemporary: function () {
      this.deleteComma((this.temporary));
    },
    // 選択項目の削除メソッド(通勤費)
    deleteCheck1(index) {
      if (this.submit_flg) return;
      // 画面上のデータを削除
      if (
        this.day1[index] ||
        this.origin[index] ||
        this.destination[index] ||
        this.route[index] ||
        this.cost[index] ||
        this.remarks[index]
      ) {
        if (
          confirm(
            "データが入力されていますが、通勤費の" +
              (index + 1) +
              "行目を削除してもよろしいですか？"
          )
        );
        else {
          // キャンセルした場合
          return;
        }
      }
      //成功時の行の削除
      this.id.splice(index, 1);
      this.day1.splice(index, 1);
      this.origin.splice(index, 1);
      this.destination.splice(index, 1);
      this.route.splice(index, 1);
      this.temporary.splice(index, 1);
      this.cost.splice(index, 1);
      this.remarks.splice(index, 1);
      this.project_id.splice(index, 1);
      this.project_name.splice(index, 1);
      this.num1--;
    },
    // 日付（通勤費）のエラーチェック
    day1_check: function () {
      this.$refs.error.day1_empty();
    },
    // 発地のエラーチェック
    origin_check: function () {
      this.$refs.error.co_origin_empty();
      this.$refs.error.origin_max();
    },
    // 着地のエラーチェック
    destination_check: function () {
      this.$refs.error.co_destination_empty();
      this.$refs.error.destination_max();
    },
    // 便名・種別・地名等のエラーチェック
    route_check: function () {
      this.$refs.error.co_route_empty();
      this.$refs.error.route_max();
    },
    // 備考のエラーチェック
    remarks_check: function () {
      this.$refs.error.remarks_max();
    },

    //保存メソッド
    edit: function () {
      if (this.editSubmit) return;
        else {
        this.loading = true;
        //フラグがfalseならば、フラグをtrueにしたうえでsubmit
        this.editSubmit = true;
        this.items = [];
        let n = 0;
        while (n < this.num1) {
          const day =
            this.day1[n].length === 1 ? "0" + this.day1[n] : this.day1[n];
          const formattedMonth =
            this.month.length === 1 ? "0" + this.month : this.month;
          //仮払入力は任意の為、replaceを行う分岐が必要
          let temporaryVal = this.temporary[n];
          if (!this.temporary[n]) {
            temporaryVal = 0;
          } else {
            temporaryVal = temporaryVal.replace(/,/g, "");
          }
          const item = {
            id: this.id[n],
            year: this.year,
            month: this.month,
            origin: this.origin[n],
            destination: this.destination[n],
            route: this.route[n],
            temporary: temporaryVal,
            project_id: this.project_id[n],
            cost: this.cost[n].replace(/,/g, ""),
            remarks: this.remarks[n],
            date: this.year + "-" + formattedMonth + "-" + day,
          };
          this.items.push(item);
          n++;
        }
        const params = new URLSearchParams();
        params.append("year", this.year);
        params.append("month", this.month);
        axios
          .post(process.env.VUE_APP_API_ORIGIN + "/updateCommute", this.items)
          .then(() => {
            alert(ConstList.REGISTER_MESSAGE);
            this.editSubmit = false;
            this.callList();
          })
          .catch((error) => {
            this.editSubmit = false;
            axios
            .get(
              `${process.env.VUE_APP_API_ORIGIN}/error/frontError/${error}`
            )
            .then(() => {
              alert(ConstList.SYSTEM_ERROR);
            })
            .catch(() => {
              alert(ConstList.SYSTEM_COMMUNICATION_ERROR);
            });
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
    digitsOnly(field, index, e) {
      // 挿入系以外（削除/移動など）は許可
      if (!e.inputType || !e.inputType.startsWith('insert')) return;

      const t = e.target;
      const data  = e.data ?? ''; // 貼り付け時は複数文字
      const start = t.selectionStart ?? t.value.length;
      const end   = t.selectionEnd   ?? t.value.length;

      // 入力適用後の値を予測
      const next = t.value.slice(0, start) + data + t.value.slice(end);

      // 半角数字以外が混じるなら未然にブロック（全角かな/全角数字/記号/空白すべてNG）
      if (!/^\d*$/.test(next)) e.preventDefault();
    },

    sanitizeDigits(field, index) {
      // 念のための最終サニタイズ（ブラウザ差・貼り付け経路の取りこぼし対策）
      const arr = this[field];
      if (!Array.isArray(arr)) return;

      const cur = String(arr[index] ?? '');
      const cleaned = cur.replace(/[^\d]/g, ''); // 非数字を全削除（全角も消える）
      if (cur !== cleaned) arr.splice(index, 1, cleaned); // Vue2はspliceでリアクティブ維持
    },
    // 表示用のラベル変換
    getStatusLabel(status) {
      if (!status) {
        return ConstList.UNSUBMITTED; // '未申請'
      }
      return status;
    },
    // 承認状態の識別
    statusColor(status) {
      const label = this.getStatusLabel(status);
      switch (label) {
        case ConstList.REJECT:
        case ConstList.UNSUBMITTED:
          return { color: 'red' };
        case ConstList.APPROVAL_PENDING:
          return { color: 'orange' };
        case ConstList.APPROVAL:
          return { color: 'green' };
        default:
          return {};
      }
    },
    // 選択変更時に name も同期（PDF や既存UIのため name も持っておく）
    syncProjectName(i) {
      const id = this.project_id[i];
      const p = this.projectList.find(x => x.id === id);
      this.$set(this.project_name, i, p ? p.name : '');
    },

    // 入力欄の追加(通勤費)
    addForm1: function () {
      if (this.submit_flg) return;
      this.num1++;
      // 1行目の project_id を既定に。なければ所属の先頭
      const baseId = this.project_id.length ? this.project_id[0] : (this.projectList[0]?.id ?? null);
      const baseName = (this.projectList.find(x => x.id === baseId)?.name) || this.project_name[0] || '';
      this.project_id.push(baseId);
      this.project_name.push(baseName);
    },
    fetchProjects() {
      axios.get(process.env.VUE_APP_API_ORIGIN + '/projects')
      .then(res => { this.projectList = res.data || []; })
      .catch(() => { this.projectList = []; });
    },
  },

  computed: {
    // 通勤費合計の計算
    totalCost: function () {
      const list = this.cost;
      const sum = this.sum_cost;
      let result = 0;
      for (let i = 0; i < list.length; i++) {
        // 金額が入力されている場合処理を行う
        if (list[i]) {
          const data = list[i].replace(/,/g, "");
          if (data) {
            const cal = parseInt(data);
            result = result + cal;
          }
        }
      }
      sum.splice(0, 1, result);
      return (
        "￥" + result.toString().replace(/([0-9]+?)(?=(?:[0-9]{3})+$)/g, "$1,")
      );
    },
    // 仮払小計の計算
    totalTemporary: function () {
      const list = this.temporary;
      const sum = this.sum_temporary;
      let result = 0;
      for (let i = 0; i < list.length; i++) {
        // 仮払金額が入力されている場合処理を行う
        if (list[i]) {
          const data = list[i].replace(/,/g, "");
          if (data) {
            const cal = parseInt(data);
            result = result + cal;
          }
        }
      }
      sum.splice(0, 1, result);
      return (
        "￥" + result.toString().replace(/([0-9]+?)(?=(?:[0-9]{3})+$)/g, "$1,")
      );
    },
    // 差引戻・払額の計算
    sumPayment: function () {
      const cost = Number(this.sum_cost?.[0]) || 0;
      const temporary = Number(this.sum_temporary?.[0]) || 0;
      const sum = cost - temporary;
      const total = this.total;
      total.splice(0, 1, sum);
      return (
        "￥" + sum.toString().replace(/([0-9]+?)(?=(?:[0-9]{3})+$)/g, "$1,")
      );
    },
    // 入力欄を追加・削除出来るようにする(通勤費)
    lists1: function () {
      return Array.from(Array(this.num1).keys());
    },
    // 保存ボタンの活性非活性
    activeButton: function () {
      const list = this.num1;
      const year = this.year;
      const day1 = this.day1;
      const cost = this.cost;
      const origin = this.origin;
      const destination = this.destination;
      const route = this.route;
      const project_id = this.project_id;
      // 行を全て削除した場合、非活性とする
      if (list === 0){
        return true;
      }
      for (let i = 0; i < list; i++) {
        if (!year || !day1[i] || !cost[i] || !origin[i] || !destination[i] || !route[i] || !project_id[i]) {
          // 全ての行から一つでも必須項目が入力されていない場合、非活性とする
          return true;
        }
      }
      // 全ての必須項目が入力されている場合、活性化する
      return false;
    },
  },

  mounted: function () {
    let today = moment();
    if (today.date() < 10) {
      today = today.subtract(1, 'months');
    }
    this.year = today.format("YYYY");
    this.month = today.format("M");
    this.day1.splice(0, 1, "");
    this.request_type.splice(0, 1, "");
    this.origin.splice(0, 1, "");
    this.destination.splice(0, 1, "");
    this.route.splice(0, 1, "");
    this.cost.splice(0, 1, "");
    this.remarks.splice(0, 1, "");
    this.temporary.splice(0, 1, "");
    this.fetchProjects();
  },
};
</script>

<style scoped>
label,
button {
  white-space: nowrap;
}

td {
  vertical-align: middle;
  white-space: nowrap;
  padding-top: 0;
  padding-bottom: 0;
}

.title {
  border: solid 1px gray;
}

.ruled-line {
  border-bottom: 1px solid #d8dbe0;
}

.frame-line {
  border: 1px solid #d8dbe0;
}

button:disabled {
  cursor: not-allowed;
}

.deleteBtn {
  height: 33px;
  margin-bottom: 18px;
  display: inline-block;
}

.btn-add {
  margin-top: 20px;
}

.btn-register {
  margin-top: 20px;
}

.asterisk {
  color: red;
}
</style>
